(function () {

    var modal = document.getElementById('ci-modal');
    var button = document.getElementsByClassName('ci-request-demo');
    var crossButton = document.getElementById('ci-request-demo-close');

    var popUp = function( event ) {

            if ( modal ) {
                modal.classList.remove( 'hide' );
            }
    };

    var popOut = function( event ) {

        if ( modal ) {
            modal.classList.add( 'hide' );
        }

    };

    if ( button ) {

        // Adding event listener to buttons.
        for ( let index = 0; index < button.length; index++ ) {
            button[ index ].addEventListener( 'click', popUp );
        }
    }

    if ( crossButton ) {
        crossButton.addEventListener( 'click', popOut );
    }

}());
